import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

//DataTable
import { StructureTableColumn } from "../../../Data/DataTables/CompanyJobsSetup";

//Types
import { ViewCompanyProfile } from "../../../Types/CompanyProfile/CompanyProfile";
import { ViewCompanyJobs } from "../../../Types/CompanyProfile/CompanyJobs";

//Services
import {
  COMPANY_JOBS_QUERY_KEY,
  VIEW_COMPANY_JOBS_QUERY_KEY,
  companyjobTitleService,
} from "../../../Services/companyjobtitleService";

//Modal
import CreateCompanyJobsModal from "../../UiKits/Modal/CompanyJobs/Create";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
};

const CompanyJobsSetupTable = ({ companyInfo }: CompanyDataProps) => {
  const company_code = companyInfo?.code || "";
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const QueryKey = [...VIEW_COMPANY_JOBS_QUERY_KEY, company_code];

  const { data: QueryData = [], isLoading: isLoading } = useQuery<
    ViewCompanyJobs[]
  >({
    queryKey: QueryKey,
    queryFn: () =>
      companyjobTitleService.viewAllJobsByCompany(company_code as string),
    select: (data) =>
      data.sort((a, b) =>
        a.job_title.toLowerCase().localeCompare(b.job_title.toLowerCase()),
      ),
  });

  const filteredItems: ViewCompanyJobs[] = QueryData.filter((item) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase()),
    ),
  );

  return (
    <>
      <br />
      <H5 className="mb-1">Job Titles Maintenance</H5>
      <P className="mb-3 f-light f-w-200 f-12">
        Allows users to create, update, and manage jobs/position for the
        specific company.
      </P>
      <CreateCompanyJobsModal company_code={company_code} />
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive theme-scrollbar">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={StructureTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default CompanyJobsSetupTable;
